import React from "react";

/**
 * Check icon component.
 *
 * @param {string} cls - class name for the svg
 * @return {JSX.Element} SVG check icon
 */
export const CheckIcon = ({ cls = "" }) => {
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g id="Group">
        <g id="Group_2">
          <path
            id="Vector"
            d="M13.1381 0.199426C12.8777 -0.0664754 12.4556 -0.0664754 12.1953 0.199426L4.20819 8.35645L1.13808 5.22105C0.877746 4.95515 0.455664 4.95518 0.195273 5.22105C-0.0650911 5.48693 -0.0650911 5.91799 0.195273 6.18389L3.73678 9.80066C3.99704 10.0665 4.41944 10.0664 4.67959 9.80066L13.1381 1.16229C13.3984 0.896414 13.3984 0.465328 13.1381 0.199426Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
};
